import { Component } from 'react';
import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ProfileIframeModal from 'crm-events-components/internal/modals/ProfileIframeModal';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
class EnhancedTimelineIframe extends Component {
  constructor(...args) {
    super(...args);
    this.renderFooter = () => {
      const {
        eventData
      } = this.props;
      return /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "timeline.compactIntegrationEvent.integrationText",
          options: {
            appName: eventData.get('appName')
          }
        })
      });
    };
  }
  render() {
    const {
      closeIframeModal,
      eventData
    } = this.props;
    const timelineIFrame = eventData.get('timelineIFrame');
    return /*#__PURE__*/_jsx(ProfileIframeModal, {
      closeIframeModal: closeIframeModal,
      footer: this.renderFooter(),
      height: timelineIFrame.get('height'),
      sandbox: ['allow-downloads'],
      title: timelineIFrame.get('iframeLabel'),
      uri: timelineIFrame.get('iframeUri'),
      width: timelineIFrame.get('width')
    });
  }
}
EnhancedTimelineIframe.displayName = 'EnhancedTimelineIframe';
EnhancedTimelineIframe.propTypes = {
  closeIframeModal: PropTypes.func.isRequired,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  eventData: PropTypes.instanceOf(ImmutableMap).isRequired
};
export default EnhancedTimelineIframe;